import styled from 'styled-components';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'react';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../Box/Box.es.js';

const StyledShelf = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-areas:
        'topLeft topCenter topRight'
        'middleLeft middleCenter middleRight'
        'bottomLeft bottomCenter bottomRight';
`;
const ShelfBaseStyles = `
    position: relative;
    display: flex;
`;
const StyledTop = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: topLeft / topLeft / topLeft / topRight;
`;
const Top = maestroComponent("Shelf.Top", StyledTop);
const StyledTopLeft = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: topLeft;
    justify-content: flex-start;
    align-items: flex-start;
`;
const TopLeft = maestroComponent("Shelf.TopLeft", StyledTopLeft);
const StyledTopCenter = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: topCenter;
    justify-content: center;
    align-items: flex-start;
`;
const TopCenter = maestroComponent("Shelf.TopCenter", StyledTopCenter);
const StyledTopRight = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: topRight;
    justify-content: flex-end;
    align-items: flex-start;
`;
const TopRight = maestroComponent("Shelf.TopRight", StyledTopRight);
const StyledMiddle = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: middleLeft / middleLeft / middleLeft / middleRight;
    justify-content: flex-start;
    align-items: flex-start;
`;
const Middle = maestroComponent("Shelf.Middle", StyledMiddle);
const StyledMiddleLeft = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: middleLeft;
    justify-content: flex-start;
    align-items: center;
`;
const MiddleLeft = maestroComponent("Shelf.MiddleLeft", StyledMiddleLeft);
const StyledMiddleCenter = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: middleCenter;
    justify-content: center;
    align-items: center;
`;
const MiddleCenter = maestroComponent("Shelf.MiddleCenter", StyledMiddleCenter);
const StyledMiddleRight = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: middleRight;
    justify-content: flex-end;
    align-items: center;
`;
const MiddleRight = maestroComponent("Shelf.MiddleRight", StyledMiddleRight);
const StyledLeft = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: topLeft / topLeft / bottomLeft / topLeft;
`;
const Left = maestroComponent("Shelf.Left", StyledLeft);
const StyledCenter = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: topCenter / topCenter / bottomCenter / topCenter;
`;
const Center = maestroComponent("Shelf.Center", StyledCenter);
const StyledRight = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: topRight / bottomRight / bottomRight / BottomRight;
`;
const Right = maestroComponent("Shelf.Right", StyledRight);
const StyledBottom = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: bottomLeft / bottomLeft / bottomLeft / bottomRight;
    justify-content: flex-start;
    align-items: flex-end;
`;
const Bottom = maestroComponent("Shelf.Bottom", StyledBottom);
const StyledBottomLeft = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: bottomLeft;
    justify-content: flex-start;
    align-items: flex-end;
`;
const BottomLeft = maestroComponent("Shelf.BottomLeft", StyledBottomLeft);
const StyledBottomCenter = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: bottomCenter;
    justify-content: center;
    align-items: flex-end;
`;
const BottomCenter = maestroComponent("Shelf.BottomCenter", StyledBottomCenter);
const StyledBottomRight = styled(Box)`
    ${ShelfBaseStyles}
    grid-area: bottomRight;
    justify-content: flex-end;
    align-items: flex-end;
`;
const BottomRight = maestroComponent("Shelf.BottomRight", StyledBottomRight);
const compoundComponents = {
  Top,
  TopLeft,
  TopCenter,
  TopRight,
  Middle,
  MiddleLeft,
  MiddleCenter,
  MiddleRight,
  Left,
  Center,
  Right,
  Bottom,
  BottomLeft,
  BottomCenter,
  BottomRight
};
const Shelf = maestroComponent("Shelf", StyledShelf, compoundComponents);

export { Shelf };
//# sourceMappingURL=Shelf.es.js.map
